import { CurrencyService } from "./../../../services/catalogs/CurrencyService";
import React from "react";
import { CurrencyDetail } from "../../../components/Pages/Catalogs/Currency/CurrencyDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateCurrencyDto } from "../../../dtos/catalogs/currency/CreateCurrencyDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCurrency } from "../../../components/Shared/NewForms/NFlookupCurrency";
import CurrencyList from "../../../components/Pages/Catalogs/Currency/CurrencyList";

export const Currency: IAppEntity = {
  entityType: "catalog",
  title: "Currency",
  pluralTitle: "Currencies",
  apiUrl: "currencies",
  apiEnum: ReferenceTypes.CatalogCurrency,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(CurrencyDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CurrencyList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCurrency, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new CurrencyService(this.apiUrl);
  },
  getEmptyModel(): CreateCurrencyDto {
    return {
      name: "",
      symbolCode: "",
      currencyCode: "",
      createdDate: new Date(),
    };
  },
};
